import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-edit-delegate',
  templateUrl: './modal-edit-delegate.component.html',
  styleUrls: ['./modal-edit-delegate.component.css']
})
export class ModalEditDelegateComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ModalEditDelegateComponent> , public dialog: MatDialog) { }

  ngOnInit() {
  }
  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }

}
